import http from '@/axios/http'

const post = ({ headers, data, url }) => {
  headers = {
    'Content-Type': 'application/json',
    ...headers
  }
  if (localStorage.getItem('token')) {
    headers.Auth = localStorage.getItem('token')
  }

  return http
    .post(
      url,
      data,
      { headers }
    )
    .then(response => response.data)
}

export const create = (robot) => {
  return post({
    url: '/robots',
    data: { ...robot }
  })
}

export const update = (robot) => {
  return post({
    url: '/update_robot',
    data: { ...robot }
  })
}

export const inspection = (robot) => {
  return post({
    url: '/both_inspection',
    data: { ...robot }
  })
}

// Checklist de inspeção (regulamento 3.1/3.2). A lista de itens e a aprovação
// das fases vêm do backend: é ele que recalcula os booleanos a cada marcação.
export const getInspectionChecklist = (info) => {
  return post({
    url: '/get_inspection_checklist',
    data: { ...info }
  })
}

export const setInspectionCheck = (info) => {
  return post({
    url: '/set_inspection_check',
    data: { ...info }
  })
}

export const image = (robot) => {
  return post({
    url: '/image_robot',
    data: { ...robot }
  })
}

// imagem avulsa de um robô (fora de /get_robots, que ficou enxuto): { robot_id }
export const getImage = (info) => {
  return post({
    url: '/get_robot_image',
    data: { ...info }
  })
}

export const getEventRobots = (info) => {
  return post({
    url: '/get_event_robots',
    data: { ...info }
  })
}

export const registerEventRobots = (info) => {
  return post({
    url: '/register_event_robots',
    data: { ...info }
  })
}
